export enum EnValidationState {
  EmailFail = 'EMAILFAIL',
  TokenInvalid = 'TOKENINVALID',
  ValidatingToken = 'VALIDATINGTOKEN',
  TokenValid = 'TOKENVALID',
  EmailSent = 'EMAILSENT',
  SendingEmail = 'SENDINGEMAIL',
  None = 'NONE'
}
